export enum eTrackerRequestType {
  New = 1,
  Renewal = 2
}

export const TrackerRequestTypeList = [
  { name: "New", mode: eTrackerRequestType.New },
  { name: "Renewal", mode: eTrackerRequestType.Renewal }
];




// WEBPACK FOOTER //
// ./src/app/enums/tracker-request-type.enum.ts